import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnInstructionDetailConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Styles.SectionContainer>
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width={80} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="rounded" width="100%" height={120} />
      </Styles.SectionContainer>
    </Styles.MainContainer>
  )
}

export default ReturnInstructionDetailConfigurationSkeleton
